import debounce from 'lodash.debounce'

const $basket = document.querySelector('.js-basket')
const $basketToggle = document.querySelector('.js-basket-toggle')

if ($basket && $basketToggle) {
  let initialHeight = `${$basket.offsetHeight}px`
  let open = false

  const ariaAttr = {
    expanded: val => $basketToggle.setAttribute('aria-expanded', val),
    hidden: val => $basket.setAttribute('aria-hidden', val)
  }

  const handleOpen = () => {
    ariaAttr.expanded(true)
    ariaAttr.hidden(false)

    $basket.style.height = initialHeight
  }

  const handleClose = () => {
    ariaAttr.expanded(false)
    ariaAttr.hidden(true)

    $basket.style.height = 0
  }

  const handleToggle = e => {
    e.preventDefault()
    open ? handleClose() : handleOpen()
    open = !open
  }

  const handleResize = debounce(() => {
    $basket.style.height = ''
    initialHeight = `${$basket.offsetHeight}px`
    $basket.style.height = open ? initialHeight : 0
  }, 50)

  open ? handleOpen() : handleClose()

  $basketToggle.addEventListener('click', handleToggle)
  window.addEventListener('resize', handleResize)
}



// WEBPACK FOOTER //
// ./src/js/_extras-basket.js